import { render, staticRenderFns } from "./PersonIconDark.vue?vue&type=template&id=77f07f8a&scoped=true&"
import script from "./PersonIconDark.vue?vue&type=script&lang=js&"
export * from "./PersonIconDark.vue?vue&type=script&lang=js&"
import style0 from "./PersonIconDark.vue?vue&type=style&index=0&id=77f07f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f07f8a",
  null
  
)

export default component.exports